enum NPSScoreCategories {
    DETRACTOR = "DETRACTOR",
    PASSIVE = "PASSIVE",
    PROMOTER = "PROMOTER",
}

export default NPSScoreCategories;
